import script from "./aiProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./aiProduct.vue?vue&type=script&lang=ts&setup=true"

import "./aiProduct.vue?vue&type=style&index=0&id=4ba540d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba540d4"]])

export default __exports__